<form (submit)="onSubmit()" class="step-form" #stepForm>
  @if (headlineTextkey) {
    <div class="grid-x grid-margin-x headline-wrapper">
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
      <div class="cell small-12 large-offset-1 large-10 text-center">
        <h1 [innerHTML]="headlineTextkey | translate"></h1>
      </div>
      <div class="cell small-12 large-offset-1 large-10"><hr></div>
    </div>
  }

  <div  class="grid-x grid-margin-x">
    <div class="cell small-12 medium-10 large-8 large-offset-2">
      <p class="step-teaser" [innerHTML]="headlineTextkey + '.teaser' | translate"></p>
    </div>
  </div>
  <div  class="grid-x grid-margin-x">
    <div class="cell small-12 medium-5 large-4 medium-order-2 help-wrapper">
      <button type="button" [attr.aria-expanded]="showPageHelp" aria-controls="inline-help" class="help-toggle hide-for-medium" (click)="togglePageHelp()">{{(showPageHelp? 'step.help.toggle.close' : 'step.help.toggle.show') | translate}} <i [class]="showPageHelp? 'icon-x-circle' : 'icon-info'"></i></button>
      @if (helpTextkey) {
        <div  class="callout lighter-gray step-help" [class.show]="showPageHelp">
          <div [innerHTML]="helpTextkey | translate"></div>
          @if (hasInlineHelp) {
            <button type="button" [attr.aria-expanded]="showInlineHelp" aria-controls="inline-help" [attr.aria-label]="'arialabel.toggle.info' | translate" (click)="toggleInlineHelp()" class="show-for-medium"><i class="icon-help-circle"></i> {{'step.help.more' | translate}}</button>
          }
        </div>
      }
    </div>
    <div class="cell small-12 medium-7 large-offset-2 large-5 medium-order-1" #formWrapper>
      @if (formError) {
        <div role="alert" class="form-errors">
          <p [innerHTML]="textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.error.' + formError | translate: backendErrorPlaceholder()"></p>
        </div>
      }
      @if (formWarning) {
        <div role="alert" class="form-warnings">
          <p [innerHTML]="textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.warning.' + formWarning | translate: backendErrorPlaceholder()"></p>
        </div>
      }

      @for (invoice of invoices; track invoice; let invoiceIndex = $index) {
        <div class="invoice invoice-{{invoiceIndex}}">
          <h2 class="background" [innerHTML]="textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.invoice.headline' | translate: {count: invoiceIndex + 1, from: form.get('abrechnung_von' + (invoiceIndex > 0? invoiceIndex : ''))?.value, to: form.get('abrechnung_bis' + (invoiceIndex > 0? invoiceIndex : ''))?.value}"></h2>
          @if (invoiceErrors[invoiceIndex]) {
            <div role="alert" class="form-errors">
              <p [innerHTML]="textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.error.invoice.' + invoiceErrors[invoiceIndex]['error'] | translate"></p>
              @if (backendErrors[invoiceIndex].length > 0) {
                <ul>
                  @for (error of backendErrors[invoiceIndex]; track error) {
                    <li [innerHTML]="error | translate: backendErrorPlaceholder()"></li>
                  }
                </ul>
              }
            </div>
          }
          @for (field of invoice; track field) {
            @if (field.isActive()) {
              <div formfield [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="showInlineHelp" [form]="form" [formModel]="field" [formConfig]="formConfig" [step]="textkeyPrefix" class="formfield {{field.type}} {{field.classes}}" [class.affected-field]="isAffectedFieldForError(invoiceIndex, field)"></div>
            }
          }
          @if (invoiceIndex > 0 && invoiceIndex === invoices.length - 1) {
            <button type="button" class="button hollow alert large" (click)="removeInvoice(invoiceIndex)">{{textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.delete.button' | translate}}</button>
          }
        </div>
      }

      @if(invoices.length <= MAX_INVOICES) {
        <div class="callout new-invoice">
          <p [innerHTML]="textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.add.teaser' | translate"></p>
          <button  type="button" class="button primary" [class.disabled]="!form.valid" (click)="addInvoice()"><i class="icon-plus-circle"></i> {{textkeyPrefix + '.verbrauchsanalyse.verbrauchsdaten.add.button' | translate}}</button>
        </div>
      }

    </div>
  </div>

  <app-step-buttons [previousLink]="previousStep? previousStep.path : null" [nextLink]="steps?.nextStep? steps.nextStep.path : null" [nextDisabled]="!form.valid" [nextClass]="loadingData? 'loading' : ''"></app-step-buttons>
</form>
